import { render, staticRenderFns } from "./ImageResize.vue?vue&type=template&id=4e2efe36&"
import script from "./ImageResize.vue?vue&type=script&lang=js&"
export * from "./ImageResize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports